import React from 'react'
import { Button, Classes } from '@blueprintjs/core'
import styled from 'styled-components'

import { BaseColumnEntry, ColumnSettingsAtom } from './types'
import ColumnSettingsViewer from './column-settings-viewer'
import ThemedDialog from '../themed-dialog'

const StyledDialog = styled(ThemedDialog)`
  overflow: hidden;
  max-height: 90vh;
  min-height: 60vh;
`

const ColumnSettingsDialog = <
  T extends string,
  U extends BaseColumnEntry<T>,
  BulkToggleKey extends string,
  OrderOptionKey extends string,
>({
  isOpen,
  onClose,
  columnSettingsAtom,
  numColumnsForToggles,
  togglingDisabledColumns,
  headerText = 'Configure Columns',
}: {
  isOpen: boolean
  onClose: () => void
  columnSettingsAtom: ColumnSettingsAtom<T, U, BulkToggleKey, OrderOptionKey>
  numColumnsForToggles: number
  togglingDisabledColumns: Set<T>
  headerText?: string
}) => {
  return (
    <StyledDialog isOpen={isOpen} title={headerText} onClose={onClose}>
      <div className={Classes.DIALOG_BODY}>
        <ColumnSettingsViewer
          {...{
            columnSettingsAtom,
            numColumnsForToggles,
            togglingDisabledColumns,
          }}
        />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button aria-label="Close" onClick={onClose} intent="primary">
            Done
          </Button>
        </div>
      </div>
    </StyledDialog>
  )
}

export default ColumnSettingsDialog
